export default {
  path: 'winter-service/v2/tasks',
  name: 'WinterService2Tasks',
  component: () => import(/* webpackChunkName: "road-maintenance" */ '../views/TasksIndex.vue')
}
